import { Injectable } from '@angular/core';
import { ComponentsService } from '@ic-builder/is-base';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { IsFormBuilderState } from './isformbuilder.state';

@Injectable()
export class IsbuilderService {
  activeEvents = [];
  activeResizeObserve = [];
  selected = [];

  @Select(IsFormBuilderState.builderscalevalue) scalevalue$: Observable<number>;

  #scalevalue = 1;
  get scalevalue() {
    return this.#scalevalue;
  }

  constructor(protected compservice: ComponentsService) {
    this.scalevalue$.subscribe((val) => (this.#scalevalue = val));
  }

  evaluateStatus(element, mode) {
    if (mode == 'middle') {
      if (getComputedStyle(element).position != 'absolute') {
        return false;
      }
    }
    if (mode == 'left') {
      if (element.style.float == 'left') {
        return false;
      }
    }
    return true;
  }

  moveComponent(comp, ev, refX, refY, corX, corY, xMoveAllowed, yMoveAllowed) {
    const parentinfo =
      comp.location.nativeElement.parentElement.getBoundingClientRect();

    const style = window.getComputedStyle(
      comp.location.nativeElement.parentElement
    );
    if (style.display == 'grid') {
      const rowHeightsSum = this.compservice.getRowHeightSum(style);
      const colWidthsSum = this.compservice.getColWidthSum(style);

      const elStyle = window.getComputedStyle(comp.location.nativeElement);
      const colLength = this.compservice.getColLength(elStyle);
      const rowLength = this.compservice.getRowLength(elStyle);

      const startRow = this.compservice.getStartRow(
        ev,
        rowHeightsSum,
        parentinfo,
        refY - corY
      );
      const startCol = this.compservice.getStartCol(
        ev,
        colWidthsSum,
        parentinfo,
        refX - corX
      );

      if (yMoveAllowed) {
        this.compservice.setDefaultStyleSub(
          comp.instance.id,
          'grid-row-start',
          startRow
        );
        if (!isNaN(rowLength))
          this.compservice.setDefaultStyleSub(
            comp.instance.id,
            'grid-row-end',
            rowLength < 0 ? -1 : startRow + rowLength
          );
      }
      if (xMoveAllowed) {
        this.compservice.setDefaultStyleSub(
          comp.instance.id,
          'grid-column-start',
          startCol
        );
        this.compservice.setDefaultStyleSub(
          comp.instance.id,
          'grid-column-end',
          colLength < 0 ? -1 : startCol + colLength
        );
      }
      this.compservice.removeClassDefinition(comp.instance.id);
      this.compservice.createWidgetStyleClass(comp.instance.id,this.compservice.styleSheet);
    } else {
      const moveLeft =
        (ev.clientX - parentinfo.left - refX + corX) / this.#scalevalue;
      const moveUp =
        (ev.clientY - parentinfo.top - refY + corY) / this.#scalevalue;

      if (xMoveAllowed) {
        comp.location.nativeElement.style.left = moveLeft.toString() + 'px';

        if (comp.instance) {
          this.compservice.setDefaultStyleSub(
            comp.instance.id,
            'left',
            moveLeft.toString() + 'px'
          );
        }
      }
      if (yMoveAllowed) {
        comp.location.nativeElement.style.top = moveUp.toString() + 'px';

        if (comp.instance) {
          this.compservice.setDefaultStyleSub(
            comp.instance.id,
            'top',
            moveUp.toString() + 'px'
          );
        }
      }
    }
  }

  resizeComponent(
    comp,
    ev,
    isGrid,
    rowHeightsSum,
    colWidthsSum,
    direction,
    corX,
    corY,
    mainComp
  ) {
    const info = comp.location.nativeElement.getBoundingClientRect();
    const parentinfo =
      comp.location.nativeElement.parentElement.getBoundingClientRect();
    const mainInfo = mainComp.getBoundingClientRect();

    const bottomDiff = info.bottom - mainInfo.bottom;
    const topDiff = info.top - mainInfo.top;
    const rightDiff = info.right - mainInfo.right;
    const leftDiff = info.left - mainInfo.left;

    const left = info.left - corX;
    const top = info.top - corY;
    const bottom = info.bottom - corY;
    const right = info.right - corX;

    let newWidth;
    let newHeight;
    let moveUp;
    let moveLeft;

    let newEndRow;
    let newStartRow;
    let newStartCol;
    let newEndCol;
    //bottomright
    if (direction == 'se') {
      if (isGrid) {
        newEndCol = this.compservice.getEndCol(
          ev,
          colWidthsSum,
          parentinfo,
          -leftDiff
        );
        newEndRow = this.compservice.getEndRow(
          ev,
          rowHeightsSum,
          parentinfo,
          -bottomDiff
        );
      } else {
        newWidth = (ev.clientX - left) / this.#scalevalue;
        newHeight = (ev.clientY - top) / this.#scalevalue;
      }
    }

    //topright
    if (direction == 'ne') {
      if (isGrid) {
        newEndCol = this.compservice.getEndCol(
          ev,
          colWidthsSum,
          parentinfo,
          -leftDiff
        );
        newStartRow = this.compservice.getStartRow(
          ev,
          rowHeightsSum,
          parentinfo,
          -topDiff
        );
      } else {
        newWidth = (ev.clientX - left) / this.#scalevalue;
        newHeight = (bottom - ev.clientY) / this.#scalevalue;

        moveUp = (ev.clientY - parentinfo.top + corY) / this.#scalevalue;
      }
    }

    //topleft
    if (direction == 'nw') {
      if (isGrid) {
        newStartCol = this.compservice.getStartCol(
          ev,
          colWidthsSum,
          parentinfo,
          -rightDiff
        );
        newStartRow = this.compservice.getStartRow(
          ev,
          rowHeightsSum,
          parentinfo,
          -topDiff
        );
      } else {
        newWidth = (right - ev.clientX) / this.#scalevalue;
        newHeight = (bottom - ev.clientY) / this.#scalevalue;

        moveUp = (ev.clientY - parentinfo.top + corY) / this.#scalevalue;
        moveLeft = (ev.clientX - parentinfo.left + corX) / this.#scalevalue;
      }
    }

    //bottomleft
    if (direction == 'sw') {
      if (isGrid) {
        newStartCol = this.compservice.getStartCol(
          ev,
          colWidthsSum,
          parentinfo,
          -rightDiff
        );
        newEndRow = this.compservice.getEndRow(
          ev,
          rowHeightsSum,
          parentinfo,
          -bottomDiff
        );
      } else {
        newWidth = (right - ev.clientX) / this.#scalevalue;
        newHeight = (ev.clientY - top) / this.#scalevalue;
        moveLeft = (ev.clientX - parentinfo.left + corX) / this.#scalevalue;
      }
    }

    //right
    if (direction == 'e') {
      if (isGrid) {
        newEndCol = this.compservice.getEndCol(
          ev,
          colWidthsSum,
          parentinfo,
          -leftDiff
        );
      } else {
        newWidth = (ev.clientX - left) / this.#scalevalue;
      }
    }

    //left
    if (direction == 'w') {
      if (isGrid) {
        newStartCol = this.compservice.getStartCol(
          ev,
          colWidthsSum,
          parentinfo,
          -rightDiff
        );
      } else {
        newWidth = (right - ev.clientX) / this.#scalevalue;
        moveLeft = (ev.clientX - parentinfo.left + corX) / this.#scalevalue;
      }
    }

    //up
    if (direction == 'n') {
      if (isGrid) {
        newStartRow = this.compservice.getStartRow(
          ev,
          rowHeightsSum,
          parentinfo,
          -topDiff
        );
      } else {
        newHeight = (bottom - ev.clientY) / this.#scalevalue;
        moveUp = (ev.clientY - parentinfo.top + corY) / this.#scalevalue;
      }
    }

    //down
    if (direction == 's') {
      if (isGrid) {
        newEndRow = this.compservice.getEndRow(
          ev,
          rowHeightsSum,
          parentinfo,
          -bottomDiff
        );
      } else {
        newHeight = (ev.clientY - top) / this.#scalevalue;
      }
    }

    if (moveLeft) {
      if (moveLeft < 0) {
        return;
      }
    } else {
      if (
        info.left - parentinfo.left + info.width >= parentinfo.width &&
        newWidth > info.width
      ) {
        return;
      }
    }

    if (moveUp) {
      if (moveUp < 0) {
        return;
      }
    } else {
      if (
        info.top - parentinfo.top + info.height >= parentinfo.height &&
        newHeight > info.height
      ) {
        return;
      }
    }

    if (moveLeft) {
      comp.location.nativeElement.style.left = moveLeft.toString() + 'px';
      this.compservice.setDefaultStyleSub(
        comp.instance.id,
        'left',
        moveLeft.toString() + 'px'
      );
    }

    if (moveUp) {
      comp.location.nativeElement.style.top = moveUp.toString() + 'px';
      this.compservice.setDefaultStyleSub(
        comp.instance.id,
        'top',
        moveUp.toString() + 'px'
      );
    }

    if (newWidth) {
      comp.location.nativeElement.style.width = newWidth.toString() + 'px';
      this.compservice.setDefaultStyleSub(
        comp.instance.id,
        'width',
        newWidth.toString() + 'px'
      );
    }

    if (newHeight) {
      comp.location.nativeElement.style.height = newHeight.toString() + 'px';
      this.compservice.setDefaultStyleSub(
        comp.instance.id,
        'height',
        newHeight.toString() + 'px'
      );
    }

    if (newStartCol) {
      this.compservice.setDefaultStyleSub(
        comp.instance.id,
        'grid-column-start',
        newStartCol
      );
      this.compservice.removeClassDefinition(comp.instance.id);
      this.compservice.createWidgetStyleClass(comp.instance.id,this.compservice.styleSheet);
    }

    if (newEndCol) {
      this.compservice.setDefaultStyleSub(
        comp.instance.id,
        'grid-column-end',
        newEndCol
      );
      this.compservice.removeClassDefinition(comp.instance.id);
      this.compservice.createWidgetStyleClass(comp.instance.id,this.compservice.styleSheet);
    }

    if (newEndRow) {
      this.compservice.setDefaultStyleSub(
        comp.instance.id,
        'grid-row-end',
        newEndRow
      );
      this.compservice.removeClassDefinition(comp.instance.id);
      this.compservice.createWidgetStyleClass(comp.instance.id,this.compservice.styleSheet);
    }

    if (newStartRow) {
      this.compservice.setDefaultStyleSub(
        comp.instance.id,
        'grid-row-start',
        newStartRow
      );
      this.compservice.removeClassDefinition(comp.instance.id);
      this.compservice.createWidgetStyleClass(comp.instance.id,this.compservice.styleSheet);
    }
  }

  cursorLogic(comp, config?) {
    if (!config?.focus) return;
    let focused;

    const focusedHandler = {
      handleEvent: () => {
        focused = true;
      },
    };

    const blurHandler = {
      handleEvent: () => {
        focused = false;
      },
    };

    const mouseLeaveHandler = {
      handleEvent: (ev) => {
        // if(focused){
        ev.currentTarget.style.cursor = 'default';
        // }
      },
    };

    const mouseMoveHandler = {
      handleEvent: (ev) => {
        // if(this.selected.includes(comp)){
        const info = ev.currentTarget.getBoundingClientRect();

        //middle
        if (
          ev.offsetX > 5 &&
          ev.offsetY > 5 &&
          info.width - ev.offsetX > 5 &&
          info.height - ev.offsetY > 5 &&
          (config?.move.left ||
            config?.move.right ||
            config?.move.top ||
            config?.move.bottom)
        ) {
          if (getComputedStyle(ev.currentTarget.parentNode).display == 'grid') {
            ev.currentTarget.style.cursor = 'grab';
            return;
          }
          if (this.evaluateStatus(ev.currentTarget, 'middle')) {
            ev.currentTarget.style.cursor = 'grab';
          } else {
            if (comp.instance.type != 'issplitter') {
              ev.currentTarget.style.cursor = 'default';
            }
          }
          //   return;
        }

        //botomright
        if (
          info.width - ev.offsetX <= 5 &&
          info.height - ev.offsetY <= 5 &&
          config?.resize.right &&
          config?.resize.bottom
        ) {
          ev.currentTarget.style.cursor = 'se-resize';
          return;
        }

        //topright
        if (
          info.width - ev.offsetX <= 5 &&
          ev.offsetY <= 5 &&
          config?.resize.right &&
          config?.resize.top
        ) {
          ev.currentTarget.style.cursor = 'ne-resize';
          return;
        }

        //topleft
        if (
          ev.offsetX <= 5 &&
          ev.offsetY <= 5 &&
          ev.currentTarget == ev.target &&
          config?.resize.top &&
          config?.resize.left
        ) {
          ev.currentTarget.style.cursor = 'nw-resize';
          return;
        }

        //bottomleft
        if (
          ev.offsetX <= 5 &&
          info.height - ev.offsetY <= 5 &&
          config?.resize.bottom &&
          config.resize.left
        ) {
          ev.currentTarget.style.cursor = 'sw-resize';
          return;
        }

        //left
        if (
          ev.offsetX <= 5 &&
          ev.currentTarget == ev.target &&
          config?.resize.left
        ) {
          if (this.evaluateStatus(ev.currentTarget, 'left')) {
            ev.currentTarget.style.cursor = 'w-resize';
          } else {
            ev.currentTarget.style.cursor = 'default';
          }
          return;
        }

        //right
        if (info.width - ev.offsetX <= 5 && config?.resize.right) {
          ev.currentTarget.style.cursor = 'e-resize';
          return;
        }

        //top
        if (
          ev.offsetY <= 5 &&
          /* ev.currentTarget == ev.target &&*/ config?.resize.top
        ) {
          ev.currentTarget.style.cursor = 'n-resize';
          return;
        }

        //bottom
        if (info.height - ev.offsetY <= 5 && config?.resize.bottom) {
          ev.currentTarget.style.cursor = 's-resize';
          return;
        }
        //ev.currentTarget.style.cursor = 'default'

        // } else {
        //   ev.currentTarget.style.cursor = 'default'
        // }
      },
    };

    comp.location.nativeElement.addEventListener('focus', focusedHandler);

    comp.location.nativeElement.addEventListener('blur', blurHandler);

    comp.location.nativeElement.addEventListener(
      'mouseleave',
      mouseLeaveHandler
    );

    comp.location.nativeElement.addEventListener('mousemove', mouseMoveHandler);

    this.activeEvents.push({
      eventname: 'focus',
      element: comp.location.nativeElement,
      handler: focusedHandler,
    });
    this.activeEvents.push({
      eventname: 'blur',
      element: comp.location.nativeElement,
      handler: blurHandler,
    });
    this.activeEvents.push({
      eventname: 'mouseleave',
      element: comp.location.nativeElement,
      handler: mouseLeaveHandler,
    });
    this.activeEvents.push({
      eventname: 'mousemove',
      element: comp.location.nativeElement,
      handler: mouseMoveHandler,
    });
  }

  moveAble(comp, config?) {
    // make action active
    let moveAble;

    let refX;
    let refY;

    let focused;

    const focusedHandler = {
      handleEvent: () => {
        focused = true;
      },
    };

    const blurHandler = {
      handleEvent: () => {
        focused = false;
      },
    };

    const mouseDownHandler = {
      handleEvent: (ev) => {
        if (ev.currentTarget.style.cursor == 'grab') {
          const info = ev.currentTarget.getBoundingClientRect();
          moveAble = true;
          refX = ev.clientX - info.left;
          refY = ev.clientY - info.top;
        }
      },
    };

    const mouseUpHandler = {
      handleEvent: () => {
        moveAble = false;
      },
    };

    const mouseMoveHandler = {
      handleEvent: (ev) => {
        if (moveAble) {
          const compInfo = comp.location.nativeElement.getBoundingClientRect();

          const info = [];
          //let top = []

          for (const sel of [...this.selected]) {
            //,{location:{nativeElement:this.editor}}
            const selInfo = sel.location.nativeElement.getBoundingClientRect();

            info.push(selInfo);
            //top.push(selInfo.top)
          }

          const minLeft = info.sort((n1, n2) => n1.left - n2.left)[0].left;
          const minTop = info.sort((n1, n2) => n1.top - n2.top)[0].top;
          const maxRight = info.sort((n1, n2) => n2.right - n1.right)[0].right;
          const maxBottom = info.sort((n1, n2) => n2.bottom - n1.bottom)[0]
            .bottom;

          const moveBlockWidth = maxRight - minLeft;
          const moveBlockHeight = maxBottom - minTop;

          const parentinfo =
            comp.location.nativeElement.parentElement.getBoundingClientRect();

          const moveAllowed = {
            left: parentinfo.left < minLeft && config?.move.left,
            right: parentinfo.right > maxRight && config?.move.right,
            up: parentinfo.top < minTop && config?.move.top,
            down: parentinfo.bottom > maxBottom && config?.move.bottom,
          };
          let xMoveAllowed;
          let yMoveAllowed;

          const childinfo = comp.location.nativeElement.getBoundingClientRect();

          if (childinfo.left + refX < ev.clientX) {
            xMoveAllowed = moveAllowed.right;
          } else {
            xMoveAllowed = moveAllowed.left;
          }

          if (childinfo.top + refY < ev.clientY) {
            yMoveAllowed = moveAllowed.down;
          } else {
            yMoveAllowed = moveAllowed.up;
          }

          for (const sel of this.selected) {
            const selInfo = sel.location.nativeElement.getBoundingClientRect();
            const corX = selInfo.left - compInfo.left;
            const corY = selInfo.top - compInfo.top;

            this.moveComponent(
              sel,
              ev,
              refX,
              refY,
              corX,
              corY,
              xMoveAllowed,
              yMoveAllowed
            );
          }
        }
      },
    };

    comp.location.nativeElement.addEventListener('focus', focusedHandler);

    comp.location.nativeElement.addEventListener('blur', blurHandler);

    comp.location.nativeElement.addEventListener('mousedown', mouseDownHandler);

    //make action inactive
    window.addEventListener('mouseup', mouseUpHandler);

    //execute action
    window.addEventListener('mousemove', mouseMoveHandler);

    this.activeEvents.push({
      eventname: 'focus',
      element: comp.location.nativeElement,
      handler: focusedHandler,
    });
    this.activeEvents.push({
      eventname: 'blur',
      element: comp.location.nativeElement,
      handler: blurHandler,
    });
    this.activeEvents.push({
      eventname: 'mousedown',
      element: comp.location.nativeElement,
      handler: mouseDownHandler,
    });
    this.activeEvents.push({
      eventname: 'mouseup',
      element: window,
      handler: mouseUpHandler,
    });
    this.activeEvents.push({
      eventname: 'mousemove',
      element: window,
      handler: mouseMoveHandler,
    });
  }
}
